
import React, { useEffect, useRef } from 'react';

import { useRecoilState } from 'recoil';
import { isChildOpenAtom, isFrostyAtom, openAppAtom } from '../recoil/isChildOpenAtom';

import {
    motion,
    //useMotionValue
} from "framer-motion";

//import Phone from './apps/Phone';
import Camera from './apps/Camera';
import Settings from './apps/Settings';
import Twitter from './apps/Twitter';
import About from './apps/About';
import Work from './apps/Work';
import Blog from './apps/Blog';
import { useHistory } from "react-router-dom";

import './FullScreen.css';

const animateSpeedSeconds = 0.34;

const FullScreen = () => {

  console.log('FullScreen render');

  let history = useHistory();
 
  const [isChildOpen, setIsChildOpen] = useRecoilState(isChildOpenAtom);
  const [openApp, setOpenApp] = useRecoilState(openAppAtom);
  
  const apps = [
    'Camera',
    'Settings',
    //'Phone',
    'Twitter',
    'About',
    'Work',
    'Blog',
  ];

  const closeApp = (e) => {
      e.preventDefault();
      setIsChildOpen(false);
      //setIsFrosty(false);

      // Make the icon show back up
      setTimeout(() => {
      const openAppEl = document.querySelector('.app-item[data-isopen=true]');
      if (openAppEl) {
          openAppEl.removeAttribute('data-isopen');
      }
      }, animateSpeedSeconds * 1000);

      const pageEl = document.querySelector(`.page[data-isopen=true]`);
      if (pageEl) {
      pageEl.removeAttribute('data-isopen');
      }

      history.push('/');
  };

  // const clearOpenAppIcon = () => {
  //   setOpenApp(curr => ({
  //     ...curr,
  //     icon: '',
  //   }))
  // };

   return (

     <motion.div
        layout
        //style={{ opacity: isFullScreenVisible ? 1 : 0 }}
        className={'fullscreen-area'}
        data-isopen={isChildOpen}
        transition={{ duration: animateSpeedSeconds }}
        onLayoutAnimationComplete={() => {
          console.log('layout complete');
          if (!isChildOpen) {
            // hack to show and hide the fullscreen area
            document.querySelector('.fullscreen-area').style.opacity = 0;
            //clearOpenAppIcon();
          }
        }}
        // onAnimationStart={onStart}
        // onAnimationComplete={onComplete}
    >
        
        <div

        >

        <div className="app-item-icon">
            <img alt={openApp.name} src={openApp.icon} />
        </div>
        
        {isChildOpen && <div className="app-open-area-body">

            {(isChildOpen && openApp.appName === 'Camera') && <Camera closeApp={closeApp} />}
            {/* {(isChildOpen && openApp.appName === 'Phone') && <Phone closeApp={closeApp} />} */}
            {(isChildOpen && openApp.appName === 'Settings') && <Settings closeApp={closeApp} />}
            {(isChildOpen && openApp.appName === 'Twitter') && <Twitter closeApp={closeApp} />}
            {(isChildOpen && openApp.appName === 'About') && <About closeApp={closeApp} />}
            {(isChildOpen && openApp.appName === 'Work') && <Work closeApp={closeApp} />}
            {(isChildOpen && openApp.appName === 'Blog') && <Blog closeApp={closeApp} />}

            {/** If app does not have it's own custom component done yet, then show a generic one */}
            {apps.indexOf(openApp.appName) === -1 && (
            <div>
                
                <h3>{openApp.appName}</h3>

                {openApp.shortText && <div style={{ fontSize: '0.7em', overflowY: 'scroll' }}>
                  <br />
                  {openApp.shortText}
                  
                </div>}

                {!openApp.shortText && <div style={{ fontSize: '0.7em' }}>
                  <br />
                  This app has not been written yet
                </div>}

                

                <div className="app-open-controls app-open-controls-single">
                  <div className="app-open-control-item"><button onClick={closeApp}>Close App</button></div>
                </div>

            </div>
            )}

        </div>}
        </div>

    </motion.div>
   );
   
 }
 
 export default FullScreen;
 